/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.11.0",
  "gitBuildTime": "2026-10-22T21:09:06.690Z",
  "gitBuildVersion": "2.11.0",
  "gitCommitId": "57e2baa",
  "gitCommitIdFull": "57e2baa221a5c105074adf5c23532abe9a4dad9f",
  "gitCommitTime": "2026-10-22T21:05:43.000Z",
  "version": "2.11.0-2026-10-22T21:05:43.000Z-(57e2baa)"
};
